<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Wimble</h1>
          <figure class="image is-4by3">
            <img src="static/images/wimble/wimble_02.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">
            Wimble is a lounge chair made of 156 used tennis balls.
          </p>
          <p>It was a teamwork between me and my two classmates Jaakko Leeve and Jaakko Hyvärinen. We were inspired by the fluffy yellow balls and their playfullness.</p>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/wimble/wimble_03-highres.jpg" src="static/images/wimble/wimble_03.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/wimble/wimble_04-highres.jpg" src="static/images/wimble/wimble_04.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default', {
      container: {
        top: 50
      }
    })
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Wimble.vue